import styles from "../SpellChecker.module.css";
import React from "react";

let Element = props => {
    return <div className={ styles.toolbox }>
        { props.children }
    </div>
}

export default Element